import { render } from "./UploadForm.vue?vue&type=template&id=43e16d33&scoped=true&ts=true&lang=pug"
import script from "./UploadForm.vue?vue&type=script&lang=ts"
export * from "./UploadForm.vue?vue&type=script&lang=ts"

import "./UploadForm.vue?vue&type=style&index=0&id=43e16d33&lang=scss&scoped=true"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Esse Group/CMS Admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43e16d33"]])

export default __exports__